<!--

    Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<ozgcloud-spinner [stateResource]="userProfileStateResource()" diameter="30" padding="3">
  <div
    data-test-class="user-profile-icon"
    [ngClass]="userIconVariants({ variant: variant() })"
    [class.bg-ozggray-900]="userProfileStateResource().resource || errorMessageCode === messageCode.RESOURCE_NOT_FOUND"
    [tooltip]="tooltip"
    aria-hidden="true"
  >
    @if (userProfileStateResource().resource) {
      <span data-test-class="user-profile-assigned">{{ initials }}</span>
    } @else {
      @if (!userProfileStateResource().error) {
        <ods-icon name="user" data-test-class="user-profile-unassigned" fill="neutral" size="extra-large" />
      }
      @if (errorMessageCode === messageCode.RESOURCE_NOT_FOUND) {
        <span data-test-class="user-profile-user-not-found">!</span>
      }
      @if (errorMessageCode === messageCode.SERVICE_UNAVAILABLE) {
        <ods-icon name="error" fill="error" size="extra-large" data-test-class="user-profile-service-unavailable" />
      }
    }
  </div>
</ozgcloud-spinner>
